/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FoodicsUser } from './FoodicsUser';
import {
    FoodicsUserFromJSON,
    FoodicsUserFromJSONTyped,
    FoodicsUserToJSON,
    FoodicsUserToJSONTyped,
} from './FoodicsUser';

/**
 * 
 * @export
 * @interface GetInactiveFoodicsUsersResponse
 */
export interface GetInactiveFoodicsUsersResponse {
    /**
     * 
     * @type {Array<FoodicsUser>}
     * @memberof GetInactiveFoodicsUsersResponse
     */
    data: Array<FoodicsUser>;
}

/**
 * Check if a given object implements the GetInactiveFoodicsUsersResponse interface.
 */
export function instanceOfGetInactiveFoodicsUsersResponse(value: object): value is GetInactiveFoodicsUsersResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetInactiveFoodicsUsersResponseFromJSON(json: any): GetInactiveFoodicsUsersResponse {
    return GetInactiveFoodicsUsersResponseFromJSONTyped(json, false);
}

export function GetInactiveFoodicsUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInactiveFoodicsUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FoodicsUserFromJSON)),
    };
}

export function GetInactiveFoodicsUsersResponseToJSON(json: any): GetInactiveFoodicsUsersResponse {
    return GetInactiveFoodicsUsersResponseToJSONTyped(json, false);
}

export function GetInactiveFoodicsUsersResponseToJSONTyped(value?: GetInactiveFoodicsUsersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(FoodicsUserToJSON)),
    };
}

